module.exports = __webpack_public_path__ + "assets/static/png/widget-phone.32178f6470d224bbf6fc5c3272ca39a7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/images/widget-phone.png
 ** module id = 539
 ** module chunks = 1
 **/